import * as React from 'react';
import * as moment from 'moment';
import Form from '../../shared/components/Form';
import TextField from '@material-ui/core/TextField';
import { Typography, Grid, Divider, Button } from '@material-ui/core';
import Role from 'src/modules/organization/models/Role';
import EditableChipList from '../../shared/components/EditableChipList';
import { withRouter, RouteComponentProps } from "react-router-dom";
import HttpService from '../../core/services/HttpService';
import Paper from '@material-ui/core/Paper'

import RequestService from '../../core/services/SubscriptionRequestService';

const httpService = HttpService.Instance;

const requestservice = RequestService.Instance;

interface IState {
  assets: any[]
  availableRoles: Role[]
  organization: any
  isLoading: boolean
}

interface IProps extends RouteComponentProps<any> {
  entity: string
  assetId: string
  subscriptionId: string
  isDefaultSubscriptionProvider: boolean
}

class Or extends React.Component<IProps, IState> {
  public assets: any[] = [];
  public organizationFormComponent: Form

  constructor(props: IProps) {
    super(props);
    this.state = {
      assets: [],
      availableRoles: [],
      organization: {},
      isLoading: true,
    }
    this.handleAddRole = this.handleAddRole.bind(this)
    this.handleDeleteRole = this.handleDeleteRole.bind(this)
  }

  public async componentDidMount() {
    const AssetResponse: Response = await httpService.get(process.env.REACT_APP_API_URL + 'assets/' + this.props.assetId);
    const AssetData: any = await AssetResponse.json();
    this.setState({ ...this.state, availableRoles: AssetData.roles })
    const organization = await requestservice.getEntity(this.props.entity);
    const subscription = await requestservice.getSubscription(this.props.subscriptionId)
    organization.roles = subscription.roles
    this.setState({ organization, isLoading: false });

  }


  public removeByKey(array: any[], key: string, value: any) {
    let indexOfMatch
    array.map((item, index) => {
      if (item[key] === value) {
        indexOfMatch = index;
      }
    })
    if (indexOfMatch !== undefined) { array.splice(indexOfMatch, 1) }
    return array
  }

  public async saveRoles(roles: Role[]) {
    await requestservice.putRoles(roles.map((r: any) => Object({ id: r.id })), this.props.subscriptionId);
  }

  public async handleDeleteRole(role: Role) {
    const organization = this.state.organization;
    organization.roles = this.removeByKey(this.state.organization.roles, 'id', role.id)
    this.setState({ ...this.state, organization })
  }

  public async handleAddRole(role: Role) {
    const organization = this.state.organization;
    organization.roles.push(role);
    this.setState({ ...this.state, organization })
  }

  public render() {

    return (
      <div>
        <Paper style={{ padding: 24 }}>
          {!this.state.isLoading &&
            <div>
              <Grid container={true} spacing={24}>
                <Grid item={true}>
                  <TextField
                    name="name"
                    label="Name"
                    value={this.state.organization.name}
                    margin="normal"
                    disabled={true}
                  />
                </Grid>
                <Grid item={true}>
                  <TextField
                    name="eori"
                    label="EORI"
                    value={this.state.organization.eori}
                    margin="normal"
                    disabled={true}
                  />
                </Grid>
                <Grid item={true}>
                  <TextField
                    name="duns"
                    label="DUNS"
                    value={this.state.organization.duns}
                    margin="normal"
                    disabled={true}
                  />
                </Grid>
                <Grid item={true}>
                  <TextField
                    name="vat"
                    label="VAT"
                    value={this.state.organization.vat}
                    margin="normal"
                    disabled={true}
                  />
                </Grid>
              </Grid>
              <Grid container={true} spacing={24} className="padding-bottom-24">
                <Grid item={true}>
                  <TextField
                    name="nxtPortId"
                    disabled={true}
                    label="NxtPort ID"
                    value={this.state.organization.nxtPortId}
                    margin="normal"
                  />
                </Grid>
                <Grid item={true}>
                  <TextField
                    name="dateAdded"
                    disabled={true}
                    label="Date Added"
                    value={moment(this.state.organization.dateAdded).format('YYYY-MM-DD')}
                    margin="normal"
                  />
                </Grid>
              </Grid>
              <Divider />
              <div className="padding-bottom-24" />

              {this.state.organization && this.state.availableRoles && this.state.availableRoles.length > 0 &&
                <div>
                  <Typography variant="subheading" gutterBottom={true}>
                    Assign Organization Roles
                  </Typography>
                  <EditableChipList
                    items={this.state.organization.roles.map((role: any) => this.state.availableRoles.find((r: any) => role.id === r.id))}
                    itemOptions={this.state.availableRoles}
                    handleAddItem={this.handleAddRole}
                    handleDeleteItem={this.handleDeleteRole}
                    labelProperty='name'
                    disbaleDoubles={true}
                    disabled = {!this.props.isDefaultSubscriptionProvider}
                  />
                  <div className="padding-bottom-24" />
                  {this.props.isDefaultSubscriptionProvider && 
                    <Button variant="raised" color="secondary" onClick={() => { this.saveRoles(this.state.organization.roles) }}>Save</Button>
                  }
                </div>
              }
            </div>
          }
        </Paper>
      </div>
    )
  }
}

export default withRouter(Or)


// WEBPACK FOOTER //
// ./src/modules/subscription/components/OrganizationForm.tsx